<div style="display: flex; flex-direction: column; height: 100%; max-height: 100%">
    <ng-content *ngIf="showTitle" select="[htmlTitle]"></ng-content>
    <div style="flex-grow: 1; display: flex; justify-content: center; align-items: center; height: 100%; width: 100%; max-height: 100%;">
        <ng-container *ngIf="isLoading; else noDataTemplate">
            <div class="spinner-container">
                <div class="spinner"></div>
            </div>
        </ng-container>

        <ng-template #noDataTemplate>
            <ng-container *ngIf="!hasData; else chartTemplate">
                <p style="text-align: center;">No data retrieved from server</p><!-- Project the no-data content -->
            </ng-container>
        </ng-template>

        <ng-template #chartTemplate>
            <ng-content select="[baseChart]"></ng-content> <!-- Project the chart content (e.g., <canvas>) -->
        </ng-template>
    </div>
</div>